import { api } from '@/lib/api';

export const labTestsService = {
  async getAll() {
    const { data } = await api.get('/lab-tests');
    return { data };
  },

  async create(body) {
    const { data } = await api.post('/lab-tests', body);
    return { data };
  },

  async update(id, body) {
    const { data } = await api.patch(`/lab-tests/${id}`, body);
    return { data };
  },

  async delete(id) {
    await api.delete(`/lab-tests/${id}`);
    return { success: true };
  },
};
